<template lang="pug">
  footer Copyright By © TEP - 2018
</template>

<script>
export default {
  name: 'Footer'
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue